import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { updateClassname } from '../utils'

function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    setTimeout(function () {
      window.scrollTo(0, 0)
      updateClassname('remove', document.body, 'scroll-disabled')
    }, 100)
  }, [pathname])

  return null
}

export default ScrollToTop
